import { COLORS, TYPO } from '@/b2b/shared/consts';
import { UiFlex } from '@/b2b/shared/ui';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface Link {
  text: string;
  url: string;
  subText?: string;
  target?: string;
}

interface LinksColumnProps {
  links: Link[];
  title: string;
  slotPosition?: 'top' | 'bottom';
  children?: ReactNode;
  onClickGiftCertificate?: () => void;
  onClickCheckupMoreInfo?: () => void;
  onClickSupervisorCatalog?: () => void;
}

export const LinksColumn: FC<LinksColumnProps> = ({
  links,
  title,
  slotPosition,
  children,
  onClickGiftCertificate,
  onClickCheckupMoreInfo,
  onClickSupervisorCatalog,
}) => {
  const handleClick = (url: string) => {
    if (url.includes('certificate')) {
      onClickGiftCertificate?.();
    }

    if (url.includes('check-up')) {
      onClickCheckupMoreInfo?.();
    }

    if (url.includes('supervisors')) {
      onClickSupervisorCatalog?.();
    }
  };

  return (
    <UiFlex
      direction="column"
      gap={slotPosition === 'top' ? 24 : 40}
    >
      <StyledTitle>{title}</StyledTitle>

      <UiFlex
        direction="column"
        gap={12}
      >
        {slotPosition === 'top' && children}
        {links.map((link, index) => (
          <StyledLink
            key={link.url}
            href={link.url}
            $isEmail={link.text.includes('@')}
            className={`link-${index + 1}`}
            target={link.target}
            onClick={() => handleClick(link.url)}
          >
            {link.text}
            {link.subText && <StyledSubText>{link.subText}</StyledSubText>}
          </StyledLink>
        ))}
        {slotPosition === 'bottom' && children}
      </UiFlex>
    </UiFlex>
  );
};

const StyledTitle = styled.p`
  color: ${COLORS.black};
  ${TYPO.body1Bold}
`;

const StyledLink = styled.a<{ $isEmail?: boolean }>`
  text-decoration: none;
  color: ${({ $isEmail }) => ($isEmail ? COLORS.primary300 : COLORS.caption)};
  ${({ $isEmail }) => ($isEmail ? TYPO.body1 : TYPO.body2)};
  ${TYPO.body2}
`;

const StyledSubText = styled.div`
  color: ${COLORS.caption};
  margin-top: 8px;
  ${TYPO.caption1}
`;
